import React from "react";

const Conversas = () => {
  return <div>Conversas</div>;
};

export default Conversas;
